import React, { PureComponent } from "react";
import PromotionalSpendChart from "./charts/promotional-spend";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../../../typeform/TypeformContent";

class PromotionalSpend extends PureComponent {
  getDataValue(team_id, key) {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    return data[team_id][key] || 0;
  }

  get productAwareness() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      data.push({
        team: teams[team_id],
        value: this.getDataValue(team_id, "Product Awareness")
      });
    });

    return data;
  }

  render() {
    return (
      <div className="col-md-3 col-xs-12">
        <div className="bg-white p-30 mh-858">
          <h5>
            PRODUCT AWARENESS
            <HelpIconButtonWithTooltipAndTypeformModal
              iconSize="sm"
              {...TypeformContent.PRODUCT_AWARENESS}
            />
          </h5>
          <hr></hr>
          <div className="mt-30">
            <PromotionalSpendChart data={this.productAwareness} />
          </div>
        </div>
      </div>
    );
  }
}

export default PromotionalSpend;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/promotional-spend.js